import { Sector } from './sector.model';

export class User {
    id?: string;
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    roles = 'super_admin';
    fullname?: string;
    sector?: Sector;
    idSector?: string;

    constructor(user) {
        if (user.id) { this.id = user.id; }
        this.firstName = user.firstName;
        this.lastName = user.lastName;
        this.email = user.email;
        this.password = user.password;
        if (user.firstName && user.lastName) { this.fullname = `${user.firstName} ${user.lastName}`; }
        if (user.sector) { this.sector = new Sector(user.sector); }
        if (user.idSector) { this.idSector = user.idSector; }
    }
}
